import { mapState } from 'pinia';
import stores from 'store/modules';
import OrganizationMixin from 'mixins/organization';
import EarlyUpgradeMixin from 'mixins/early-upgrade';

export default {
    mixins: [OrganizationMixin, EarlyUpgradeMixin],

    computed: {
        ...mapState(stores.ComplianceProfile, ['profileBusiness']),
    },

    methods: {
        handleShowTrustedCallingBuy(status = false, type) {
            if (!this.profileBusiness.hasBusinessProfileV2) {
                this.handleUpdateBusinessProfile();

                return;
            }

            const access = this.handleShowAnotherModals();

            if (!access) return;

            this.$store.dispatch('handleShowTrustedCallingBuy', {
                status: status,
                type: type,
            });
        },

        handleShowShakenStirAdvanced(status = false) {
            const access = this.handleShowAnotherModals();

            if (!access) return;

            this.$store.dispatch('handleShowShakenStirAdvancedModal', status);
        },

        handleShowShakenStirDeleteModal(status) {
            this.$store.dispatch('handleShowShakenStirDeleteModal', status);
        },

        handleShowCNAMCallerID(status = false) {
            const access = this.handleShowAnotherModals();

            if (!access) return;

            this.$store.dispatch('handleShowCNAMCallerIDModal', status);
        },

        handleShowCNAMCallerDelete(cnam) {
            const access = this.handleShowAnotherModals();

            if (!access) return;

            this.$store.dispatch('handleShowCNAMDeleteModal', {
                status: Boolean(cnam),
                item: cnam || null,
            });
        },

        handleShowCNAMCallerEdit(cnam) {
            const access = this.handleShowAnotherModals();

            if (!access) return;

            this.$store.dispatch('handleShowCNAMEditModal', {
                status: Boolean(cnam),
                item: cnam || null,
            });
        },

        closeVoiceIntegrityModal() {
            this.$store.dispatch('fetchVoiceIntegrity');
        },
    },
};
